import { render, staticRenderFns } from "./cn_user_left_pannel.vue?vue&type=template&id=cd81da70&scoped=true&"
import script from "./cn_user_left_pannel.vue?vue&type=script&lang=js&"
export * from "./cn_user_left_pannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd81da70",
  null
  
)

export default component.exports